import { Injectable } from "@angular/core";
import { HomeFeedProvider } from "../../shared/nestjs/home-feed/home-feed";
import { Subscription } from "rxjs";
import { ResponseGetTeammatesDto } from "../../shared/nestjs/gd-only/dto/home-feed.dto";

@Injectable()
export class TeammatesBloc {
	private _subscriptions: Array<Subscription> = [];
	private _limitTeammates = 4;
	private _loadingGetTeammates = false;
	private _teammatesList: ResponseGetTeammatesDto[];

	constructor(
		private homeFeedProvider: HomeFeedProvider
	) {

	}

	getTeammates(): Promise<void> {
		return new Promise((resolve) => {
			this._loadingGetTeammates = true;
			this._subscriptions.push(
				this.homeFeedProvider.getTeamMates(1, this._limitTeammates)
					.map(res => res.data)
					.subscribe(result => {
						this._teammatesList = result;
						this._loadingGetTeammates = false;
						resolve();
					}, (_) => {
						this._loadingGetTeammates = false;
						resolve();
					})
			);
		});
	}

	getSupervisor(): Promise<any> {
		return new Promise((resolve, reject) => {
			this.homeFeedProvider.getSupervisor()
				.map(res => res.data)
				.subscribe(result => {
					resolve(result);
				}, error => {
					reject(error);
				})
		})
	}

	get teammatesList() {
		return this._teammatesList;
	}

	get loadingGetTeammates() {
		return this._loadingGetTeammates;
	}
}


// WEBPACK FOOTER //
// ./src/bloc/company/teammates.bloc.ts